<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @onChangeAccsGroup="onChangeAccsGroup"
        @download="download"/>

      <basic-table
        @Filtred="Filtred"
        :items="expiringPayments"
        :fields="expiringPaymentsFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        limit: 500,
        download: 0
      },
      expiringPayments: [],
      expiringPaymentsFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'first_date', label: this.$i18n.t('First payment date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'last_date', label: this.$i18n.t('Last payment date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'burn_date', label: this.$i18n.t('Expiration date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'amount',
          label: this.$i18n.t('Volume'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'already_discounted', label: this.$i18n.t('Already charged off'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_EXPIRING_PAYMENTS', this.getStore).then(response => {
        if (isGenerateClick) {
          this.expiringPayments = this.$store.getters['Reports/EXPIRING_PAYMENTS']
        } else {
          download(this.$store.getters['Reports/EXPIRING_PAYMENTS'], 'report_payments_expiring_payments.csv', 'text/csv')
        }

        this.loadDone()
      })
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_PAYMENTS')
      this.getStore.download = 0
      this.totalRows = 0
      this.expiringPayments = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/expiringPayments/main.vue